export default {
  headers: [
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.drivers', 'driver'],
    ['satellite-tracking/report.date', 'date'],
    ['satellite-tracking/report.type', 'type'],
    ['satellite-tracking/report.cost', 'cost'],
    ['satellite-tracking/report.note', 'note']
  ]
}
